import apiService from "./apiService";
export const getSignedUrl = async (url: string) => {
  const response = await apiService({
    path: `${process.env.SIGNED_LINK_URL}?url=${url}`,
    method: "GET",
  });
  return response.results?.signedUrl;
};
